import { z } from 'zod';
import { AuditedFields, Email, Locale, PhoneE164, Uuid, Version } from './common.js';
export const TenantStatus = z.enum(['TRIAL', 'ACTIVE', 'SUSPENDED']);
export const Address = z.object({
    line1: z.string().max(200).nullable(),
    line2: z.string().max(200).nullable(),
    poBox: z.string().max(50).nullable(),
    city: z.string().max(100).nullable(),
    countryCode: z.string().length(2),
});
export const Tenant = z
    .object({
    id: Uuid,
    slug: z.string(),
    legalName: z.string(),
    tradeName: z.string().nullable(),
    status: TenantStatus,
    countryCode: z.string().length(2),
    currencyCode: z.string().length(3),
    timezone: z.string(),
    defaultLocale: Locale,
    legal: z.object({
        rccm: z.string().nullable(),
        ifu: z.string().nullable(),
        taxRegime: z.string().nullable(),
        taxDivision: z.string().nullable(),
        legalForm: z.string().nullable(),
    }),
    contact: z.object({
        email: Email.nullable(),
        phone: PhoneE164.nullable(),
        website: z.string().url().nullable(),
        address: Address.nullable(),
    }),
    bankDetails: z.object({
        bankName: z.string().nullable(),
        accountNumber: z.string().nullable(),
        iban: z.string().nullable(),
        swift: z.string().nullable(),
    }),
    branding: z.object({
        logoUrl: z.string().nullable(),
        primaryColor: z
            .string()
            .regex(/^#[0-9a-fA-F]{6}$/)
            .nullable(),
        secondaryColor: z
            .string()
            .regex(/^#[0-9a-fA-F]{6}$/)
            .nullable(),
        documentSignatory: z.string().nullable(),
    }),
    version: Version,
})
    .merge(AuditedFields);
export const UpdateTenantRequest = Tenant.pick({
    legalName: true,
    tradeName: true,
    legal: true,
    contact: true,
    bankDetails: true,
    branding: true,
})
    .partial()
    .extend({ version: Version });
export const Property = z
    .object({
    id: Uuid,
    code: z.string(),
    name: z.string(),
    address: Address.nullable(),
    timezone: z.string(),
    /** Heure à partir de laquelle le check-in est possible (D-021 : 12:00). */
    checkinFrom: z.string().regex(/^\d{2}:\d{2}$/),
    /** Heure limite de check-out (D-021 : 12:00). */
    checkoutUntil: z.string().regex(/^\d{2}:\d{2}$/),
    isActive: z.boolean(),
    version: Version,
})
    .merge(AuditedFields);
export const CreatePropertyRequest = Property.pick({
    code: true,
    name: true,
    address: true,
    timezone: true,
    checkinFrom: true,
    checkoutUntil: true,
});
export const UpdatePropertyRequest = CreatePropertyRequest.partial().extend({
    isActive: z.boolean().optional(),
    version: Version,
});
//# sourceMappingURL=tenant.js.map